import * as React from 'react';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authLayout/analytics/$fundId')({
  component: AnalyticsItemComponent,
});

function AnalyticsItemComponent() {
  // const [fund, setHierarchy ] = React.useState<HierarchyResponse[] | null>(null);
  // const [menu, setMenu] = React.useState<ReactNode | null>(null)
  // useEffect(() => {
  //   endpointHierarchyGET().then((res) => {
  //     console.log(res)
  //     // setHierarchy(res??null);
  //     if (res) {
  //       setMenu(<AccordionMenu items={hierarchy2DocMenu(res)} />)
  //     }
  //   })
  // }, [])

  return <div>dashboard</div>;
}
